var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analise" },
    [
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              configuracaoFiltro: _vm.configuracaoFiltro,
              filtro: _vm.filtro,
              isConsultaProcessosAntigos: true
            },
            on: {
              pesquisar: _vm.pesquisarFiltro,
              limpar: _vm.clearFiltro,
              changePesquisa: _vm.changePesquisa
            }
          })
        ],
        1
      ),
      _c(
        "app-listagem",
        {
          attrs: {
            hasActionButton: true,
            sizeActionButton: false,
            showButtonCadastrar: false,
            hasHeader: true,
            hasRefreshButton: false,
            headerLabel: _vm.headerLabel,
            dataForTable: _vm.items,
            totalElements: _vm.totalElements,
            pagina: _vm.filtro.pagina + 1
          },
          on: {
            click: _vm.cadastrar,
            changePage: _vm.changePage,
            sort: _vm.sort
          }
        },
        [
          _c(
            "template",
            { slot: "columns" },
            [
              _c("el-table-column", {
                attrs: {
                  label: "Número do processo",
                  prop: "numeroProcesso",
                  "min-width": "120",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Nome/Razão social do interessado",
                  prop: "nomeRazaoSocialInteressado",
                  "min-width": "120",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "CPF/CNPJ do interessado",
                  prop: "cpfCnpjInteressado",
                  "min-width": "120",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  formatter: function(row) {
                    return _vm.setData(row.dataCadastro)
                  },
                  label: "Data de Cadastro",
                  "min-width": "120",
                  prop: "dataAlterado",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Município",
                  "min-width": "120",
                  prop: "municipio",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Área(ha)",
                  prop: "areaTotal",
                  formatter: function(row) {
                    return _vm.formatarArea(row.areaImovel)
                  },
                  "min-width": "120",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "Ações", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click", size: "small" } },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "mini" } },
                              [
                                _vm._v("Ações"),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right"
                                })
                              ]
                            ),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("el-dropdown-item", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          on: {
                                            click: function($event) {
                                              return _vm.visualizar(scope.row)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-eye icon-teste"
                                          }),
                                          _vm._v("  Visualizar")
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "container-exportar" },
        [
          _c("el-button", { on: { click: _vm.exportar } }, [
            _c("span", [
              _c("i", { staticClass: "fal fa-file-csv" }),
              _vm._v("  Exportar CSV")
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19f1541e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f1541e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/bancoDados/consultaProcessosAntigos/ConsultaProcessosAntigos.vue
// module id = null
// module chunks = 